import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== "production") {
      console.error("ErrorBoundary caught:", error, errorInfo);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    const { hasError, error } = this.state;
    const { children, fallbackTitle } = this.props;

    if (!hasError) {
      return children;
    }

    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center px-6 py-16 text-center">
        <h1 className="mb-3 text-xl font-bold text-[#333]">
          {fallbackTitle || "Something went wrong"}
        </h1>
        <p className="mb-6 max-w-md text-sm leading-relaxed text-[#666]">
          The page could not load properly. Please try again or return to the homepage.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <button
            type="button"
            onClick={this.handleRetry}
            className="rounded-full bg-[#801520] px-5 py-2.5 text-sm font-semibold text-white"
          >
            Try again
          </button>
          <a
            href="/"
            className="rounded-full border border-[#d9d9d9] px-5 py-2.5 text-sm font-semibold text-[#333]"
          >
            Go home
          </a>
        </div>
        {process.env.NODE_ENV !== "production" && error?.message ? (
          <pre className="mt-6 max-w-xl overflow-auto rounded-lg bg-[#f5f5f5] p-3 text-left text-xs text-[#800040]">
            {error.message}
          </pre>
        ) : null}
      </div>
    );
  }
}

export default ErrorBoundary;
